import React from 'react'
import {Icon} from '@chakra-ui/react'

const HeaderRight = (props) => {
    return (
        <Icon viewBox="0 0 16 16" width="16" height="16" fill="none" {...props} aria-hidden="true">
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.31388 2.46535C5.50543 2.30574 5.7988 2.32191 5.96902 2.50148L11.0423 7.85228L6.16974 13.0162C6 13.1961 5.70674 13.213 5.51476 13.0538C5.32278 12.8946 5.30487 12.6197 5.47461 12.4398L9.80206 7.85367L5.27544 3.07947C5.10522 2.89991 5.12234 2.62496 5.31388 2.46535Z"
                stroke="#0C2340"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default HeaderRight
